import IWaveScore from './IWaveScore';

const IWaveEvaluationI18nMap: Record<IWaveScore, string> = {
  [IWaveScore.WEAK]: 'IWAVE_SCORE_EVALUATION_1',
  [IWaveScore.FAIR]: 'IWAVE_SCORE_EVALUATION_2',
  [IWaveScore.GOOD]: 'IWAVE_SCORE_EVALUATION_3',
  [IWaveScore.STRONG]: 'IWAVE_SCORE_EVALUATION_4',
};

export default IWaveEvaluationI18nMap;
